module.exports = __webpack_public_path__ + "img/keder_signalgelb_ral1003.675d64e8.jpg";